export function Wordmark({ className = "" }) {
  return (
    <span
      data-testid="brand-wordmark"
      className={`font-outfit font-black tracking-tight text-slate-900 select-none ${className}`}
    >
      FIRST<span className="text-blue-600">SIGNAL</span>
    </span>
  );
}
